"use client"
import {
  Checkbox as MuiCheckbox,
  Stack,
  StackProps,
  SxProps,
  Typography,
} from "@mui/material"
import {
  CheckBoxOutlinedBlankIcon,
  CheckBoxOutlinedIcon,
} from "@tc/ui-dfe/icons"
import { ChangeEvent, useId } from "react"

export interface CheckboxProps {
  name?: string
  id?: string
  checked?: boolean
  label?: string
  stackProps?: StackProps
  sx?: SxProps
  disabled?: boolean
  onChange?: (checked: boolean) => void
  alignItems?: "start" | "center" | "end" | "stretch"
}

export const Checkbox = (props: CheckboxProps) => {
  const { name, id, label, onChange, checked, sx, alignItems = "start" } = props
  const autoId = useId()
  const _id = id || autoId
  const handleChange = (_: ChangeEvent<HTMLInputElement>, checked: boolean) => {
    onChange?.(checked)
  }
  return (
    <Stack display="flex" direction="row" gap={1} alignItems={alignItems}>
      <Stack sx={{ pt: 0.5 }}>
        <MuiCheckbox
          id={_id}
          name={name}
          onChange={handleChange}
          inputProps={
            {
              "data-testid": _id,
            } as React.InputHTMLAttributes<HTMLInputElement>
          }
          sx={{
            p: 0,
            mt: "-2px",
            "&.Mui-checked": {
              color: "forest.main",
            },
            ...sx,
          }}
          disabled={props.disabled}
          checked={checked}
        />
      </Stack>
      <Typography variant="h5">{label}</Typography>
    </Stack>
  )
}
